module.exports = __webpack_public_path__ + "static/img/my.369c4d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my.png
// module id = 4Ysc
// module chunks = 0